import React, { useState } from 'react';
import { FaDownload, FaShare, FaTimes } from 'react-icons/fa';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

function GiftCard() {
  const [selectedFlyer, setSelectedFlyer] = useState(null);

  const flyers = [
    'giftcard2026.jpg'
  ];

  const handleFlyerClick = (flyer) => {
    setSelectedFlyer(flyer);
  };

  const handleCloseModal = () => {
    setSelectedFlyer(null);
  };

  const handleSave = () => {
    const link = document.createElement('a');
    link.href = `/images/flyers/${selectedFlyer}`;
    link.download = selectedFlyer;
    link.click();
  };

  const handleShare = async () => {
    const shareData = {
      title: selectedFlyer.replace('.jpeg', ''),
      text: 'Check out this gift card from Bramble Farm Therapy',
      url: window.location.origin + `/images/flyers/${selectedFlyer}`
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log('Error sharing:', err);
        fallbackShare();
      }
    } else {
      fallbackShare();
    }
  };

  const fallbackShare = () => {
    navigator.clipboard.writeText(window.location.origin + `/images/flyers/${selectedFlyer}`)
      .then(() => alert('Image URL copied to clipboard!'))
      .catch(() => alert('Copy this link: ' + window.location.origin + `/images/flyers/${selectedFlyer}`));
  };

  return (
    <div className="boarding-page">
      <Header />
      <Menu />
      <main className="boarding-content">
        <h1>Gift Cards</h1>
        <div className="flyers-grid">
          {flyers.map((flyer, index) => (
            <img
              key={index}
              src={`/images/flyers/${flyer}`}
              alt={flyer.replace('.jpg', '').replace(/([A-Z])/g, ' $1').trim()}
              className="flyer-image"
              onClick={() => handleFlyerClick(flyer)}
            />
          ))}
        </div>
      </main>
      <Footer />
      <ScrollToTop />

      {selectedFlyer && (
        <div className="flyer-modal" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`/images/flyers/${selectedFlyer}`}
              alt={selectedFlyer.replace('.jpg', '').replace(/([A-Z])/g, ' $1').trim()}
              className="modal-image"
            />
            <div className="modal-menu">
              <button className="modal-btn" onClick={handleSave}>
                <FaDownload /> Save
              </button>
              <button className="modal-btn" onClick={handleShare}>
                <FaShare /> Share
              </button>
              <button className="modal-btn close-btn" onClick={handleCloseModal}>
                <FaTimes /> Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GiftCard;